<template>
  <div class="ui-railing"
       :style="{ 'webkitTransform': transformation, 'transform': transformation, 'width': screenWidth, 'height': screenHeight }"
       @contextmenu="showContextMenu($event)"
  >
  </div>
</template>

<script>
  import interact from 'interactjs';

  export default {
    name: "Railing",

    props: {
      myRailing: Object,
      bookingMode: Boolean
    },

    computed: {
      screenWidth() {
        return this.myRailing.width + 'px';
      },
      screenHeight() {
        return this.myRailing.height + 'px';
      },
      top() {
        return this.myRailing.y + 'px';
      },
      left() {
        return this.myRailing.x + 'px';
      },
      transformation() {
        return 'translate(' + this.left + ', ' + this.top + ')';
      }
    },

    methods: {
      showContextMenu(event) {
        this.$emit('show-railing-context-menu', event);
      },
      resizeListener (event) {
        // Get coordinates
        let railingX = (parseFloat(this.myRailing.x) || 0),
          railingY = (parseFloat(this.myRailing.y) || 0),
          railingWidth = event.rect.width,
          railingHeight = event.rect.height;

        railingX += event.deltaRect.left;
        railingY += event.deltaRect.top;

        // Emit the resize/drag move event
        this.$emit('railing-moved', { x: railingX, y: railingY, width: railingWidth, height: railingHeight });
      },
      dragMoveListener (event) {
        // Get coordinates
        let newX = (parseFloat(this.myRailing.x) || 0) + event.dx,
          newY = (parseFloat(this.myRailing.y) || 0) + event.dy;

        // Emit the resize/drag move event
        this.$emit('railing-moved', { x: newX, y: newY });
      }
    },

    mounted() {
      if (! this.bookingMode) {
        interact(this.$el)
          .draggable({
            onmove: this.dragMoveListener,
            restrict: {
              restriction: 'parent',
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            },
          })
          .resizable({
            // resize from all edges and corners
            edges: { left: true, right: true, bottom: true, top: true },

            // keep the edges inside the parent
            restrictEdges: {
              outer: 'self',
              endOnly: true,
            },

            // minimum size
            restrictSize: {
              min: { width: 10, height: 10 },
            },

            inertia: true,
          })
          .on('resizemove', this.resizeListener);
      }
    }
  }
</script>

<style scoped>
  .ui-railing {
    text-align: center;
    border: solid 1px black;
    position: absolute;

    /* This makes things *much* easier */
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Railing.vue